export default __webpack_public_path__ + "fa4b9ff549212ee1e2ec14d245f2a4d9.png";